import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_DML_REPORTS} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const DMLReport = lazy(() =>
  import('../../../screens/DMLReport')
    .then(module => ({default: module.DMLReport})));

const DMLReportNavigation = [
  {
    path: ROUTE_DML_REPORTS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <DMLReport />
      </Suspense>
    ),
  },
];

export default DMLReportNavigation;
